"use strict";
const Library = require("./Library");
class Client {
    constructor({ auth, api }) {
        this.auth = auth;
        if (api) {
            this.api = api;
        }
        else {
            const ParticleClass = require('./Particle');
            this.api = new ParticleClass();
        }
    }
    ready() {
        return Boolean(this.auth);
    }
    libraries(query = {}) {
        return this.api.listLibraries(Object.assign({}, query, { auth: this.auth }))
            .then((payload) => {
            const libraries = payload.body.data || [];
            return libraries.map((l) => new Library(this, l));
        });
    }
    library(name, query = {}) {
        return this.api.getLibrary(Object.assign({}, query, { name, auth: this.auth }))
            .then((payload) => {
            const library = payload.body.data || {};
            return new Library(this, library);
        });
    }
    libraryVersions(name, query = {}) {
        return this.api.getLibraryVersions(Object.assign({}, query, { name, auth: this.auth }))
            .then((payload) => {
            const libraries = payload.body.data || [];
            return libraries.map((l) => new Library(this, l));
        });
    }
    contributeLibrary(archive) {
        return this.api.contributeLibrary({ archive, auth: this.auth })
            .then((payload) => {
            const library = payload.body.data || {};
            return new Library(this, library);
        }, (error) => {
            this._throwError(error);
        });
    }
    publishLibrary(name) {
        return this.api.publishLibrary({ name, auth: this.auth })
            .then((payload) => {
            const library = payload.body.data || {};
            return new Library(this, library);
        }, (error) => {
            this._throwError(error);
        });
    }
    deleteLibrary({ name, force }) {
        return this.api.deleteLibrary({ name, force, auth: this.auth })
            .then(() => true, (error) => this._throwError(error));
    }
    _throwError(error) {
        if (error.body && error.body.errors) {
            const errorMessages = error.body.errors.map((e) => e.message).join('\n');
            throw new Error(errorMessages);
        }
        throw error;
    }
    downloadFile(uri) {
        return this.api.downloadFile({ uri });
    }
    compileCode(files, platformId, targetVersion) {
        return this.api.compileCode({ files, platformId, targetVersion, auth: this.auth });
    }
    signalDevice({ signal, deviceId }) {
        return this.api.signalDevice({ signal, deviceId, auth: this.auth });
    }
    listDevices() {
        return this.api.listDevices({ auth: this.auth });
    }
    listBuildTargets() {
        return this.api.listBuildTargets({ onlyFeatured: true, auth: this.auth })
            .then((payload) => {
            const targets = [];
            for (const target of payload.body.targets) {
                for (const platform of target.platforms) {
                    targets.push({
                        version: target.version,
                        platform: platform,
                        prerelease: target.prereleases.indexOf(platform) > -1,
                        firmware_vendor: target.firmware_vendor
                    });
                }
            }
            return targets;
        }, () => []);
    }
    trackingIdentity({ full = false, context } = {}) {
        return this.api.trackingIdentity({ full, context, auth: this.auth })
            .then((payload) => {
            return payload.body;
        });
    }
}
module.exports = Client;
//# sourceMappingURL=Client.js.map